// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-panel[data-v-1c731620]{background-color:#fff;box-shadow:0 1px 2px rgba(0,0,0,.05),0 2px 4px rgba(0,0,0,.05),0 4px 8px rgba(0,0,0,.05),0 8px 16px rgba(0,0,0,.05);color:#000;transition:opacity .1s ease-in-out;width:100%;z-index:30}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
